import React from 'react';
import PropTypes from 'prop-types';
import { Location } from '@gatsbyjs/reach-router';
import { getQueryParams } from '../../../utils/query-params';
import { VisuallyHidden } from '../../styled/accessibility';
import {
  PrimaryNavSplitBtn,
  StyledDonateButton,
  SearchBtnToggle,
  MobileMenuBtn,
} from './styles';

export const DonateButton = ({ size }) => {
  const getReservedAppealCode = ({ search }) => {
    const urlParams = getQueryParams(search);
    return urlParams.reserved_appeal_code || '';
  };

  return (
    <Location>
      {({ location }) => {
        const path = getReservedAppealCode(location)
          ? `/donate?reserved_appeal_code=${getReservedAppealCode(location)}`
          : `/donate`;

        return (
          <StyledDonateButton
            link={{ path }}
            bg="primary"
            size={size}
            data={{ headerlink: 'donate' }}
          >
            Donate
          </StyledDonateButton>
        );
      }}
    </Location>
  );
};
DonateButton.propTypes = {
  size: PropTypes.string,
};

export const MobileSearchToggle = ({ active, onClick }) => (
  <SearchBtnToggle
    type="button"
    onClick={onClick}
    $active={active}
    size="small"
    bg={active ? 'default' : 'secondary-standard'}
    icon={active ? 'cross' : 'search'}
    iconPlacement="center"
    aria-expanded={active}
    aria-label="Toggle Search"
  >
    <VisuallyHidden as="legend">Toggle Search</VisuallyHidden>
  </SearchBtnToggle>
);
MobileSearchToggle.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export const MobileMenuToggle = React.forwardRef(({ onClick, active }, ref) => (
  <MobileMenuBtn
    type="button"
    onClick={onClick}
    aria-expanded={active}
    icon={active ? 'cross' : 'menu'}
    iconPlacement="right"
    size="small"
    bg="secondary-outline"
    data={{ headernav: 'hamburger' }}
    ref={ref}
  >
    Menu
  </MobileMenuBtn>
));

MobileMenuToggle.displayName = 'MobileMenuToggle';

MobileMenuToggle.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export const PrimaryNavItem = ({ children = '' }) => (
  <PrimaryNavSplitBtn $bg="secondary-standard">{children}</PrimaryNavSplitBtn>
);
PrimaryNavItem.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};
